import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
// Material
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
// RxJS
import { BehaviorSubject, Observable, of } from 'rxjs';
// NGRX
import { Update } from '@ngrx/entity';
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../../core/reducers';
// Services and Models
import {
  AffiliationsService,
  PatientHeightModel,
  PatientHeightsService,
  PatientModel,
  PatientOnServerCreated,
  PatientOnServerUpdated,
  PatientsService,
  PatientWeightModel,
  PatientWeightsService,
  selectLastCreatedPatient,
  selectPatientErrorState,
  selectPatientsActionLoading,
  SharedHttpRequestService,
  NoteEntityType,
} from '../../../../../../core/lists';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TranslateService } from '@ngx-translate/core';
import { PatientWeightComponent } from '../_subs/patient-weight/patient-weight.component';
import { PatientHeightComponent } from '../_subs/patient-height/patient-height.component';
import { GeneralAutocompleteComponent } from '../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { AuthService, currentUserPermissions } from '../../../../../../core/auth';
import { GeneralValidationMessagesService } from '../../../../../../core/services/general-validation-messages.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { ViewFileDialogComponent } from 'src/app/views/partials/content/crud/view-file-dialog/view-file-dialog.component';
import * as moment from 'moment';
import { CreateFilteredViewDialogComponent } from '../../../../filtered-view/create-filtered-view-dialog/create-filtered-view-dialog.component';
import { GlobalSettingsService } from '../../../../../../core/services/global-settings.service';
import { take } from 'rxjs/operators';
import { MapsAPILoader } from '@agm/core';
import OpenLocationCode from 'open-location-code-typescript';
import { StartFocusedViewFromEntityComponent } from '../../../../../partials/content/general/start-focused-view-from-entity/start-focused-view-from-entity.component';
import { ZoomInEntityComponent } from '../../../../../partials/content/general/zoom-in-entity/zoom-in-entity.component';
import { NavigationService } from '../../../../../../core/services/navigation.service';
import { PictureCropperComponent } from '../../../../../partials/content/general/picture-cropper/picture-cropper.component';
import { ImageSettingService } from '../../../../../../core/services/image-setting.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM-DD-YYYY',
  },
  display: {
    dateInput: 'MM-DD-YYYY',
    monthYearLabel: 'MMM, YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'kt-patient-edit',
  templateUrl: './patient-edit.component.html',
  styleUrls: ['./patient-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class PatientEditComponent implements OnInit, OnDestroy {
  // for HTML template use
  NoteEntityType = NoteEntityType;
  //
  patient: PatientModel;
  patientId$: Observable<number>;
  oldPatient: PatientModel;
  patientForm: FormGroup;
  hasFormErrors = false;
  hasSubmissionErrors = false;
  submissionErrorObj: any;
  viewLoading = false;
  loading$: Observable<boolean>;
  holdChecked = false;
  hospitalChecked = false;
  weight_kg = '';
  weight_lb = '';
  height_cm = '';
  height_ft = 0;
  height_in = 0;
  facility_id = 0;
  facility_name = '';
  measurementSystem = localStorage.getItem('measurementSystem');
  private subscriptions: any[] = [];
  tags = new FormControl();
  tags$ = new BehaviorSubject<any>([]);
  patientDevices$ = new BehaviorSubject([]);
  hasDeviceAlerts: boolean;
  isViewMode: boolean;
  isViewMode$: Observable<boolean>;
  readOnly = false;
  tagsArr = [];
  @ViewChild('facilityAutocomplete') facilityAutocomplete: GeneralAutocompleteComponent;
  facilityAutocompleteCall = this.patientsService.searchFacilities.bind(this.patientsService);
  @ViewChild('speciesAutocomplete') speciesAutocomplete: GeneralAutocompleteComponent;
  speciesAutocompleteCall = this.patientsService.searchSpecies.bind(this.patientsService);
  basicInfo: any = { avatar: '/assets/media/patients/UndefinedPatient.svg' };
  maxDate: any;
  private newAvatar = null;
  private needToChangeImage = false;
  urbanizationValue;
  Address1Value;
  Address2Value;
  cityValue;
  zipValue;
  formChanged = false;
  params: any;
  needToChange = false;
  geocoder;
  lat = null;
  lng = null;
  @Input() entity_id;
  @Input() fromCanvas;
  isFocusedView = false;
  @ViewChild('relationsAutocomplete') relationsAutocomplete: GeneralAutocompleteComponent;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() focusedViewOpen = new EventEmitter<any>();
  @Output() navigateToContact = new EventEmitter<any>();
  patientProfile;
  defaultFemalePatient = '/assets/media/patients/FemalePatient.svg';
  defaultMalePatient = '/assets/media/patients/MalePatient.svg';
  defaultUndefinedPatient = '/assets/media/patients/UndefinedPatient.svg';
  tabs = [
    { index: 0, label: 'General Info', icon: 'mat-tab-label-icon fa fa-info', active: true },
    {
      index: 1,
      label: 'Notes',
      icon: 'flaticon-notes icon-md',
      active: false,
      permission: 'canViewNote',
    },
    {
      index: 2,
      label: 'Insurance',
      icon: 'mat-tab-label-icon fa flaticon-safe-shield-protection',
      active: false,
    },
    {
      index: 3,
      label: 'Prescriptions',
      icon: 'mat-tab-label-icon fas fa-capsules',
      active: false,
    },
    {
      index: 4,
      label: 'Relations',
      icon: 'mat-tab-label-icon fas fa-people-arrows',
      active: false,
      permission: 'canViewRelation',
    },
    {
      index: 5,
      label: 'Other Details',
      icon: 'mat-tab-label-icon fas fa-ellipsis-h',
      active: false,
    },
    {
      index: 6,
      label: 'Documents',
      icon: 'mat-tab-label-icon icon-lg fa fa-file-alt',
      active: false,
    },
    {
      index: 7,
      label: 'Tasks',
      icon: 'mat-tab-label-icon fas fa-tasks',
      active: false,
      permission: 'accessToTaskModule',
    },
    {
      index: 8,
      label: 'Med Review',
      icon: 'mat-tab-label-icon flaticon2-writing',
      active: false,
      permission: 'accessMedReview',
    },
    { index: 9, label: 'History', icon: 'mat-tab-label-icon fas fa-history', active: false },
    {
      index: 10,
      label: 'Devices',
      icon: 'mat-tab-label-icon fas fa-laptop-medical',
      active: false,
      permission: 'accessToRemoteMonitoringModule',
    },
    {
      index: 11,
      label: 'Affiliations',
      icon: 'mat-tab-label-icon icon-lg fa fa-handshake',
      active: false,
    },
  ];
  loadingData = false;
  constructor(
    private navigationService: NavigationService,
    private globalService: GeneralValidationMessagesService,
    public dialogRef: MatDialogRef<PatientEditComponent>,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private patientsService: PatientsService,
    private patientWeightsService: PatientWeightsService,
    private patientHeightsService: PatientHeightsService,
    public dialog: MatDialog,
    private sharedHttpRequestService: SharedHttpRequestService,
    private affiliationsService: AffiliationsService,
    private authService: AuthService,
    private globalSettings: GlobalSettingsService,
    public stringUtils: StringUtilsService,
    private mapsAPILoader: MapsAPILoader,
    private titleCasePipe: TitleCasePipe,
    private imageSettingService: ImageSettingService,
  ) {
    this.maxDate = new Date();
    window.addEventListener('beforeunload', (event) => {
      if (this.formChanged) {
        event.returnValue = 'You have unfinished changes!';
      }
    });
    this.mapsAPILoader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });
  }

  ngOnInit() {
    this.isFocusedView = this.globalSettings.isFilteredView();

    if (this.entity_id) {
      this.globalService.getEntitiesById('patients', this.entity_id).subscribe((result) => {
        if (result) {
          this.loadPatient(result.data);
          this.cdr.detectChanges();
        }
      });
      return;
    }

    // this line due to make the navigation service return to patient list if there is no ->
    // navigation stack saved before in special cases
    this.navigationService.setDefaultRoot('/lists/patients');

    this.activatedRoute.queryParams.subscribe((params) => {
      params.tab_index ? this.changeTab(+params.tab_index) : this.changeTab(0);
    });
    this.loading$ = this.store.pipe(select(selectPatientsActionLoading));
    const routeSubscription = this.activatedRoute.params.subscribe((params) => {
      const id = params.id;
      if (id && id > 0) {
        const patientByIdSub = this.globalService
          .getEntitiesById('patients', id)
          .subscribe((result) => {
            if (result) {
              this.loadPatient(result.data);
              this.cdr.detectChanges();
              return;
            }
          });
        this.subscriptions.push({ id: 2, sub: patientByIdSub });
      } else {
        this.patient = new PatientModel();
        this.patient.clear();
        this.oldPatient = Object.assign({}, this.patient);
        this.initPatient();
      }
    });
    this.subscriptions.push({ id: 1, sub: routeSubscription });
    if (!this.entity_id)
      if (this.activatedRoute.url[`_value`][1]?.path === 'view') {
        this.readOnly = true;
        this.cdr.detectChanges();
      }
  }

  private loadPatient(res) {
    this.patient = res;
    if (this.patient.id > 0) this.loadTags();
    this.getBasicInfo();
    this.getPatientDevices();
    this.oldPatient = Object.assign({}, this.patient);
    this.initPatient();
    this.patientId$ = of(this.patient.id);
    if (this.patient.facility_id && this.patient.facility_id !== 0) {
      const patientServiceSub = this.patientsService
        .getFacility(this.patient.facility_id)
        .subscribe((result) => {
          if (result.data) {
            this.facility_name = result.data.name;
            this.facility_id = result.data.id;
            setTimeout(() => {
              this.facilityAutocomplete?.setValue({
                id: this.facility_id,
                last_name: this.facility_name,
              });
            });
          } else {
            this.facility_name = '';
            this.facility_id = 0;
          }
          this.createForm();
        });
      this.subscriptions.push({ id: 3, sub: patientServiceSub });
    }
    const patientWeightSub = this.patientWeightsService
      .getPatientWeights(this.patient.id)
      .subscribe((result) => {
        if (result.data) {
          const sortedResult = result.data.sort((a, b) => {
            const x = a.start_date;
            const y = b.start_date;
            return x < y ? -1 : x > y ? 1 : 0;
          });
          if (sortedResult.length > 0) {
            this.weight_kg = this.convertWeight(sortedResult[sortedResult.length - 1].weight);
            this.weight_lb = this.convertWeight(sortedResult[sortedResult.length - 1].weight);
            this.createForm();
          }
        }
      });
    this.subscriptions.push({ id: 4, sub: patientWeightSub });
    const patientHeightSub = this.patientHeightsService
      .getPatientHeights(this.patient.id)
      .subscribe((result) => {
        if (result.data) {
          const sortedResult = result.data.sort((a, b) => {
            const x = a.start_date;
            const y = b.start_date;
            return x < y ? -1 : x > y ? 1 : 0;
          });
          if (sortedResult.length > 0) {
            this.height_cm = sortedResult[sortedResult.length - 1].height;
            this.height_ft = this.convertHeightFt(sortedResult[sortedResult.length - 1].height);
            this.height_in = this.convertHeightIn(sortedResult[sortedResult.length - 1].height);
            this.createForm();
          }
        }
      });
    this.subscriptions.push({ id: 5, sub: patientHeightSub });
  }

  private loadTags() {
    this.sharedHttpRequestService
      .getTagsForView(this.patient.id, tagsViewContext.ENTITIES)
      .subscribe((tags) => {
        this.tags$.next(tags.data);
        this.tagsArr = tags.data;
      });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.sub.unsubscribe());
  }

  initPatient() {
    this.createForm();
  }

  createForm() {
    this.patientForm = this.fb.group({
      first_name: [this.patient.first_name, Validators.required],
      last_name: [this.patient.last_name, Validators.required],
      middle_name: [this.patient.middle_name],
      last_name2: [this.patient.last_name2],
      dob: [
        this.patient.dob !== null && this.patient.dob !== ''
          ? new Date(`${this.patient.dob}T00:00:00`)
          : '',
        Validators.required,
      ],
      gender: [this.patient.gender ? this.patient.gender : ''],
      primary_language: [this.patient.primary_language],
      patient_class: [this.patient.patient_class],
      facility_id: [{ id: this.facility_id, last_name: this.facility_name }],
      species: [null],
      address_1: [
        this.patient.address_1,
        Validators.compose([Validators.required, Validators.maxLength(48)]),
      ],
      address_2: [this.patient.address_2, Validators.maxLength(48)],
      city: [
        this.patient.city,
        Validators.compose([Validators.required, Validators.maxLength(30)]),
      ],
      state: [this.patient.state, Validators.required],
      urbanization: [this.patient.urbanization, Validators.maxLength(48)],
      fax: [
        this.patient.fax !== '' && this.patient.fax !== null
          ? '(' +
            this.patient.fax.substring(0, 3) +
            ') ' +
            this.patient.fax.substring(3, 6) +
            '-' +
            this.patient.fax.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      zip: [
        this.patient.zip,
        Validators.compose([Validators.required, Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)]),
      ],
      // tslint:disable-next-line:max-line-length
      home_phone: [
        this.patient.home_phone !== '' && this.patient.home_phone !== null
          ? '(' +
            this.patient.home_phone.substring(0, 3) +
            ') ' +
            this.patient.home_phone.substring(3, 6) +
            '-' +
            this.patient.home_phone.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      // tslint:disable-next-line:max-line-length
      cell_phone: [
        this.patient.cell_phone !== '' && this.patient.cell_phone !== null
          ? '(' +
            this.patient.cell_phone.substring(0, 3) +
            ') ' +
            this.patient.cell_phone.substring(3, 6) +
            '-' +
            this.patient.cell_phone.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      email: [this.patient.email, Validators.email],
      hold_flag: [this.patient.hold_flag],
      hold_date: [
        this.patient.hold_date !== null && this.patient.hold_date !== ''
          ? new Date(this.patient.hold_date)
          : '',
      ],
      hold_note: [this.patient.hold_note],
      in_hospital: [this.patient.in_hospital],
      // tslint:disable-next-line:max-line-length
      in_hospital_date: [
        this.patient.in_hospital_date !== null && this.patient.in_hospital_date !== ''
          ? new Date(this.patient.in_hospital_date)
          : '',
      ],
      is_active: [this.patient.is_active],
      deceased: [
        this.patient.deceased_date !== null && this.patient.deceased_date !== ''
          ? new Date(`${this.patient.deceased_date}T00:00:00`)
          : '',
      ],
      height_ft: this.height_ft,
      height_in: this.height_in,
      height_cm: this.height_cm,
      weight_kg: this.weight_kg,
      weight_lb: this.weight_lb,
      last_modified_user: this.patient.last_modified_user,
      latitude: [{ value: this.patient.latitude ? this.patient.latitude : null, disabled: true }],
      longitude: [
        { value: this.patient.longitude ? this.patient.longitude : null, disabled: true },
      ],
      plus_code: [{ value: this.patient.plus_code, disabled: true }],
      geolocation_address: [this.patient.geolocation_address],
      office_number: [this.patient.office_number],
      extension: [this.patient.extension],
    });
    if (this.patient?.species) {
      this.patientForm.controls.species.setValue(this.patient.species);
      setTimeout(() => {
        this.speciesAutocomplete?.setValue(this.patient.species);
      }, 600);
    }
    this.holdChecked = this.patient.hold_flag;
    this.hospitalChecked = this.patient.in_hospital;
    if (!this.patient.id) {
      this.isViewMode = false;
    } else if (!this.entity_id && this.activatedRoute.url[`_value`][1]?.path === 'view') {
      this.isViewMode = true;
      this.patientForm.disable();
      this.patientForm.controls.geolocation_address.enable();
    } else {
      const permissionSub = this.store.pipe(select(currentUserPermissions)).subscribe((res) => {
        if (!res.some((p) => p.name === 'canEditPatient')) {
          this.patientForm.disable();
          this.patientForm.controls.geolocation_address.enable();
          this.readOnly = true;
          this.cdr.detectChanges();
        }
      });
      this.subscriptions.push({ id: 14, sub: permissionSub });
      this.isViewMode = false;
    }
    this.urbanizationValue = this.patient.urbanization;
    this.Address1Value = this.patient.address_1;
    this.Address2Value = this.patient.address_2;
    this.cityValue = this.patient.city;
    this.zipValue = this.patient.zip;
    this.isViewMode$ = of(this.isViewMode);
    if (
      (!this.patient?.latitude || !this.patient?.longitude) &&
      !this.patient.geolocation_address &&
      this.patient?.plus_code
    ) {
      const area = OpenLocationCode.decode(this.patientForm.get('plus_code').value);
      this.setCoordinates(area.latitudeCenter, area.longitudeCenter);
      setTimeout(() => {
        this.setGeolocationAddress(area.latitudeCenter, area.longitudeCenter);
      }, 2500);
    }
    if (
      this.patient?.latitude &&
      this.patient?.longitude &&
      !this.patient?.plus_code &&
      !this.patient?.geolocation_address
    ) {
      this.setCoordinates(this.patient.latitude, this.patient.longitude);
      this.setGeolocationAddress(this.patient.latitude, this.patient.longitude);
      setTimeout(() => {
        this.setGeolocationAddress(this.patient.latitude, this.patient.longitude);
      }, 2500);
      this.patientForm
        .get('plus_code')
        .setValue(OpenLocationCode.encode(this.patient.latitude, this.patient.longitude));
    }
    this.basicInfo.avatar = this.patient.pre_signed_url?.url
      ? this.patient.pre_signed_url.url
      : this.patient.gender
      ? this.patient.gender === 'FEMALE'
        ? this.defaultFemalePatient
        : this.defaultMalePatient
      : this.defaultUndefinedPatient;
    this.patientProfile = this.basicInfo.avatar
      ? this.basicInfo.avatar
      : this.defaultUndefinedPatient;
    this.loadingData = true;
    setTimeout(() => {
      this.patientForm.valueChanges.subscribe(() => {
        this.formChanged = true;
        this.authService.setChanged(true);
      });
    }, 3000);
  }
  markerDragEnd($event: any) {
    this.setCoordinates($event.latLng.lat(), $event.latLng.lng());
    this.setGeolocationAddress(this.lat, this.lng);
  }

  setCoordinates(lat, lng) {
    this.patientForm.get('latitude').setValue(lat);
    this.patientForm.get('longitude').setValue(lng);
    this.lng = lng;
    this.lat = lat;
    this.cdr.detectChanges();
  }

  setGeolocationAddress(lat, lng) {
    const latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };
    this.geocoder?.geocode({ location: latLng }, (response: any) => {
      if (response && response[0]) {
        this.patientForm
          .get('geolocation_address')
          .setValue(response && response[0]?.formatted_address);
      } else {
        window.alert('No results found');
      }
    });
  }

  resetGeolocation() {
    this.patientForm.get('geolocation_address').setValue(null);
    this.patientForm.get('plus_code').setValue(null);
    this.patientForm.get('latitude').setValue(null);
    this.patientForm.get('longitude').setValue(null);
  }

  searchForGeolocation() {
    this.globalSettings
      .getPlusCode(this.patientForm.get('geolocation_address').value)
      .subscribe((res) => {
        if (res.status === 'OK' || res.status === 'ok') {
          this.patient.geolocation_address = this.patientForm.get('geolocation_address').value;
          this.patient.plus_code = res?.plus_code?.global_code;
          this.patient.latitude = res?.plus_code?.geometry?.location?.lat;
          this.patient.longitude = res?.plus_code?.geometry?.location?.lng;
          this.patientForm.get('plus_code').setValue(res?.plus_code?.global_code);
          this.patientForm.get('latitude').setValue(res?.plus_code?.geometry?.location?.lat);
          this.patientForm.get('longitude').setValue(res?.plus_code?.geometry?.location?.lng);
          return;
        }
        const message = 'We could not find: ' + this.patientForm.get('geolocation_address').value;
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Read,
          3000,
          true,
          false,
        );
      });
  }

  goBack() {
    if (this.entity_id) return;
    this.navigationService.goBack();
  }

  reset() {
    const _title = this.translate.instant('DIALOG.RESET');
    const _description = this.translate.instant('DIALOG.ARE_YOU_SURE');
    const _waitDesciption = this.translate.instant('DIALOG.RESETING');

    const dialogRef = this.layoutUtilsService.confirmAction(_title, _description, _waitDesciption);
    if (this.subscriptions.find((sub) => sub.id === 7) === undefined) {
      const resetSub = dialogRef.afterClosed().subscribe((res) => {
        if (!res) {
          return;
        }
        this.patient = Object.assign({}, this.oldPatient);
        this.createForm();
        this.hasFormErrors = false;
        this.patientForm.markAsPristine();
        this.patientForm.markAsUntouched();
        this.patientForm.updateValueAndValidity();
      });
      this.subscriptions.push({ id: 7, sub: resetSub });
    }
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.patientForm.controls;
    /** check form */
    this.facilityAutocomplete?.updateValueAndValidity();

    if (this.patientForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.changeTab(0);
      this.hasFormErrors = true;
      return;
    }

    this.formChanged = false;
    this.authService.setChanged(false);
    if (!this.patient.id) {
      this.createPatient(this.preparePatient());
    } else {
      this.updatePatientImage(() => {
        const editedPatient = this.preparePatient();
        if (editedPatient.id > 0) {
          this.updatePatient(editedPatient);
          return;
        }

        return null;
      });
    }
  }

  getBasicInfo() {
    if (!this.patient || !this.patient.id) {
      return;
    }

    const id = this.patient.patient_id ? this.patient.patient_id : '';
    const deceased_date = this.patient.deceased_date
      ? this.datePipe.transform(this.patient.deceased_date, 'MM-dd-yyyy')
      : '';
    const status = this.patient.is_active ? this.patient.is_active : false;
    const first = this.patient.first_name ? this.patient.first_name : '';
    const middle = this.patient.middle_name ? this.patient.middle_name : '';
    const last = this.patient.last_name ? this.patient.last_name : '';
    const last2 = this.patient.last_name2 ? this.patient.last_name2 : '';
    const gender = this.patient.gender ? this.patient.gender : null;
    const dob = this.patient.dob ? this.datePipe.transform(this.patient.dob, 'MM-dd-yyyy') : '';
    const firstLet = this.patient.first_name
      ? this.patient.first_name.substring(0, 1).toUpperCase()
      : '';
    const lastLet = this.patient.last_name
      ? this.patient.last_name.substring(0, 1).toUpperCase()
      : '';
    const avatar = this.patient.pre_signed_url?.url
      ? this.patient.pre_signed_url.url
      : this.patient.gender
      ? this.patient.gender === 'FEMALE'
        ? this.defaultFemalePatient
        : this.defaultMalePatient
      : this.defaultUndefinedPatient;
    this.basicInfo = {
      id,
      status,
      first,
      last,
      last2,
      gender,
      dob,
      firstLet,
      lastLet,
      deceased_date,
      fullName: (first + ' ' + middle + ' ' + last + ' ' + last2).trim(),
      avatar,
    };
  }

  preparePatient(): PatientModel {
    const controls = this.patientForm.controls;
    const _patient = new PatientModel();
    _patient.id = this.patient.id;
    _patient.first_name = controls.first_name.value;
    _patient.middle_name = controls.middle_name.value;
    _patient.last_name = controls.last_name.value;
    _patient.last_name2 = controls.last_name2.value;
    _patient.dob = this.datePipe.transform(controls.dob.value, 'yyyy-MM-dd');
    _patient.gender = controls.gender.value ? controls.gender.value : null;
    _patient.primary_language = controls.primary_language.value;
    _patient.patient_class = controls.patient_class.value;
    _patient.facility_id =
      controls.facility_id.value && controls.facility_id.value !== 0
        ? controls.facility_id.value
        : null;
    _patient.address_1 = controls.address_1.value;
    _patient.address_2 = controls.address_2.value;
    _patient.city = controls.city.value;
    _patient.deceased_date = this.datePipe.transform(controls.deceased.value, 'yyyy-MM-dd');
    _patient.state = controls.state.value ? controls.state.value.toUpperCase() : '';
    _patient.zip = controls.zip.value;
    _patient.home_phone =
      controls.home_phone.value !== null
        ? controls.home_phone.value.replace(/\D/g, '')
        : controls.home_phone.value;
    _patient.cell_phone =
      controls.cell_phone.value !== null
        ? controls.cell_phone.value.replace(/\D/g, '')
        : controls.cell_phone.value;
    _patient.email = controls.email.value;
    _patient.hold_flag = controls.hold_flag.value;
    _patient.hold_date = this.datePipe.transform(controls.hold_date.value, 'yyyy-MM-dd hh:mm:ss');
    _patient.hold_note = controls.hold_note.value;
    _patient.in_hospital = controls.in_hospital.value;
    _patient.in_hospital_date = this.datePipe.transform(
      controls.in_hospital_date.value,
      'yyyy-MM-dd hh:mm:ss',
    );
    _patient.is_active = controls.is_active.value;
    _patient.patient_id = this.patient.patient_id;
    _patient.patient_no = this.patient.patient_no;
    _patient.processed = this.patient.processed;
    _patient.note = this.patient.note;
    _patient.office_id = this.patient.office_id;
    _patient.diagnosis = this.patient.diagnosis;
    _patient.other_allergies = this.patient.other_allergies;
    _patient.other_medications = this.patient.other_medications;
    _patient.icd = this.patient.icd;
    _patient.tags = this.tags.value;
    _patient.urbanization = controls.urbanization.value;
    _patient.urbanization = controls.urbanization.value;
    _patient.geolocation_address = controls.geolocation_address.value;
    _patient.plus_code = controls.plus_code.value;
    _patient.latitude = controls.latitude.value;
    _patient.longitude = controls.longitude.value;
    _patient.extension = controls.extension.value;
    _patient.office_number =
      controls.office_number.value != null
        ? controls.office_number.value.replace(/\D/g, '')
        : controls.office_number.value;
    _patient.species = controls.species.value;
    _patient.office_number =
      controls.office_number.value != null
        ? controls.office_number.value.replace(/\D/g, '')
        : controls.office_number.value;
    if (this.needToChangeImage || this.needToChange) {
      _patient.avatar = this.basicInfo.avatarUUID;
    } else {
      _patient.avatar = this.patient.avatar;
    }
    _patient.fax =
      controls.fax.value !== null ? controls.fax.value.replace(/\D/g, '') : controls.fax.value;
    if (_patient.facility_id[`id`] === 0) {
      _patient.facility_id = null;
    }
    for (const [key, value] of Object.entries(_patient)) {
      if (typeof value === 'string') {
        _patient[key] = value.trim();
      }
    }
    return _patient;
  }

  updatePatient(_patient: PatientModel) {
    if (_patient?.facility_id && _patient.facility_id?.id) {
      _patient.facility_id = _patient.facility_id.id;
    }
    const updatePatient: Update<PatientModel> = {
      id: _patient.id,
      changes: _patient,
    };
    this.store.dispatch(
      new PatientOnServerUpdated({
        partialPatient: updatePatient,
        patient: _patient,
      }),
    );
    if (this.subscriptions.find((sub) => sub.id === 8) === undefined) {
      const actionLoadingSubscription = this.store
        .pipe(select(selectPatientsActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            this.store.pipe(select(selectPatientErrorState)).subscribe((error) => {
              if (error) {
                if (error.status) {
                  this.submissionErrorObj = error.error.errors;
                } else {
                  this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                }
                this.hasSubmissionErrors = true;
              } else if (this.router.routerState.snapshot.url !== '/lists/patients') {
                this.submissionErrorObj = null;
                this.hasSubmissionErrors = false;
                let message = '';
                if (!this.needToChangeImage) {
                  message = this.translate.instant('PATIENT.EDIT.UPDATE_MESSAGE');
                  this.layoutUtilsService.showActionNotification(
                    message,
                    MessageType.Update,
                    3000,
                    false,
                    false,
                  );
                  this.goBack();
                } else {
                  this.globalService
                    .getEntitiesById('patients', this.patient.id)
                    .subscribe((patient) => {
                      if (patient) {
                        this.needToChangeImage = false;
                        this.loadPatient(patient.data);
                        this.loadTags();
                        message = 'Patient picture changed successfully';
                        this.layoutUtilsService.showActionNotification(
                          message,
                          MessageType.Update,
                          3000,
                          false,
                          false,
                        );
                        this.cdr.detectChanges();
                        return;
                      }
                    });
                }
              }
            });
          }
          this.cdr.detectChanges();
        });
      this.subscriptions.push({ id: 8, sub: actionLoadingSubscription });
    }
  }
  closeDialog(e) {
    if (e) {
      this.focusedViewOpen.emit(true);
      this.navigateToContact.emit(true);
    }
  }

  createPatient(_patient: PatientModel) {
    this.store.dispatch(new PatientOnServerCreated({ patient: _patient }));
    if (this.subscriptions.find((sub) => sub.id === 10) === undefined) {
      const actionLoadingSubscription = this.store
        .pipe(select(selectPatientsActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            if (this.subscriptions.find((sub) => sub.id === 11) === undefined) {
              const errorStateSubscription = this.store
                .pipe(select(selectPatientErrorState))
                .subscribe((error) => {
                  if (error) {
                    if (error.status) {
                      this.submissionErrorObj = error.error.errors;
                    } else {
                      this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                    }
                    this.hasSubmissionErrors = true;
                  } else if (this.router.routerState.snapshot.url !== '/lists/patients') {
                    this.submissionErrorObj = null;
                    this.hasSubmissionErrors = false;
                    const message = this.translate.instant('PATIENT.EDIT.ADD_MESSAGE');
                    this.layoutUtilsService.showActionNotification(
                      message,
                      MessageType.Update,
                      10000,
                      false,
                      false,
                    );
                    this.goBack();
                  }
                  this.cdr.detectChanges();
                });
              this.subscriptions.push({ id: 11, sub: errorStateSubscription });
            }
          }
          this.cdr.detectChanges();
        });

      setTimeout(
        () =>
          this.store.pipe(select(selectLastCreatedPatient), take(1)).subscribe((val) => {
            if (!val) {
              return;
            }
            this.patient = val;
            this.updatePatientImage(() => {
              const editedPatient = this.preparePatient();
              if (editedPatient.id > 0) {
                this.updatePatient(editedPatient);
                return;
              }

              return null;
            });
          }),
        500,
      );
      this.subscriptions.push({ id: 10, sub: actionLoadingSubscription });
    }
  }

  onAlertClose() {
    this.hasFormErrors = false;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.patientForm.controls[controlName];
    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  expandWeightHistory(patient) {
    // tslint:disable-next-line:prefer-const
    const newWeight = new PatientWeightModel();
    newWeight.clear(patient.id);
    const dialogRef = this.dialog.open(PatientWeightComponent, {
      data: {
        id: patient.id,
      },
    });
    if (this.subscriptions.find((sub) => sub.id === 12) === undefined) {
      const dialogRefSub = dialogRef.afterClosed().subscribe((res) => {
        if (res && res.weight) {
          this.weight_kg = this.convertWeight(res.weight);
          this.weight_lb = this.convertWeight(res.weight);
        }
      });
      this.subscriptions.push({ id: 12, sub: dialogRefSub });
    }
  }

  expandHeightHistory(patient) {
    // tslint:disable-next-line:prefer-const
    const newHeight = new PatientHeightModel();
    newHeight.clear(patient.id);
    const dialogRef = this.dialog.open(PatientHeightComponent, {
      data: {
        id: patient.id,
      },
    });
    if (this.subscriptions.find((sub) => sub.id === 12) === undefined) {
      const dialogRefSub = dialogRef.afterClosed().subscribe((res) => {
        if (res && res.height) {
          this.height_cm = res.height;
          if (this.measurementSystem !== 'm') {
            this.height_ft = this.convertHeightFt(res.height);
            this.height_in = this.convertHeightIn(res.height);
          }
        }
      });
      this.subscriptions.push({ id: 13, sub: dialogRefSub });
    }
  }

  convertWeight(weight) {
    if (this.measurementSystem === 'm') {
      return (weight / 1000).toFixed(2);
    } else {
      return (weight / 454).toFixed(2);
    }
  }

  convertHeightFt(height) {
    return Math.floor(height / 2.54 / 12);
  }

  convertHeightIn(height) {
    return Math.round(height / 2.54 - 12 * Math.floor(height / 2.54 / 12));
  }

  getPatientDevices() {
    this.patientsService.getPatientDevices(this.patient.id).subscribe((res) => {
      this.patientDevices$.next(res);
      this.hasDeviceAlerts = this.hasAlerts(res);
    });
  }

  hasAlerts(patientDevices) {
    for (const device of patientDevices) {
      if (device.alerts.length > 0) {
        return true;
      }
    }
    return false;
  }

  editPatient(patient: PatientModel) {
    this.navigationService.navigateTo('lists/patients/edit/' + patient.id);
  }

  onFacilityChange(val) {
    this.patientForm.controls.facility_id.setValue(val.id);
    this.patientForm.controls.facility_id.updateValueAndValidity();
  }

  onSpeciesChange(val) {
    this.patientForm.controls.species.setValue(val);
    this.patientForm.controls.species.updateValueAndValidity();
  }

  getStatusString(): string {
    switch (this.patientForm.get('is_active').value) {
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
    }
    return '';
  }

  updateProfile() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '600px';
    dialogConfig.height = '400px';
    const defaultImage = this.patient.gender
      ? this.patient.gender === 'FEMALE'
        ? this.defaultFemalePatient
        : this.defaultMalePatient
      : this.defaultUndefinedPatient;
    if (this.patient.id) {
      this.globalService.getEntitiesById('patients', this.patient.id).subscribe((patient) => {
        if (patient?.data) {
          dialogConfig.data = {
            existImage: patient?.data?.pre_signed_url?.url,
            mode: 'UPDATE',
            defaultImage,
          };
          const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              switch (result.mode) {
                case 'DELETE': {
                  this.needToChangeImage = true;
                  const editedPatient = this.preparePatient();
                  editedPatient.avatar = null;
                  if (editedPatient.id > 0) {
                    this.updatePatient(editedPatient);
                    return;
                  }
                  break;
                }
                case 'UPDATE': {
                  if (result.img) {
                    this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                    this.needToChangeImage = true;
                    const reader = new FileReader();
                    reader.readAsDataURL(this.newAvatar);
                    reader.onloadend = () => {
                      this.basicInfo.avatar = reader.result;
                      this.cdr.detectChanges();
                    };
                    let editedPatient = this.preparePatient();
                    if (editedPatient.id > 0) {
                      this.updatePatientImage(() => {
                        editedPatient = this.preparePatient();
                        if (editedPatient.id > 0) {
                          this.updatePatient(editedPatient);
                          return;
                        }
                        return null;
                      });
                      return;
                    }
                  }
                  break;
                }
              }
            }
          });
        }
      });
    } else {
      dialogConfig.data = { existImage: null, mode: 'UPDATE', defaultImage };
      const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          switch (result.mode) {
            case 'UPDATE': {
              if (result.img) {
                this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                this.patientProfile = result.img;
                this.needToChangeImage = true;
                const reader = new FileReader();
                reader.readAsDataURL(this.newAvatar);
                reader.onloadend = () => {
                  this.basicInfo.avatar = reader.result;
                  this.cdr.detectChanges();
                };
              }
              break;
            }
          }
        }
      });
    }
  }

  setMaxDate($event: MatDatepickerInputEvent<any>) {
    this.maxDate = $event.value;
  }

  private updatePatientImage(cc) {
    if (this.needToChangeImage) {
      return this.patientsService
        .updatePatientImage(this.newAvatar, this.patient.id)
        .subscribe((res2) => {
          this.patientsService.uploadPatientImage(res2, this.newAvatar).subscribe(() => {
            this.basicInfo.avatarUUID = res2.data.uuid;
            cc();
          });
        });
    } else {
      cc();
    }
  }

  putDash(e) {
    let x = e;
    if (x.length === 6 && x.charAt(5) !== '-') {
      x = x.slice(0, 5) + '-' + x.charAt(x.length - 1);
    }
    return x;
  }

  viewFiles() {
    const dialogFile = this.dialog.open(ViewFileDialogComponent, {
      data: {
        title: 'Previous photos',
        type: 'entities',
        id: this.patient.id,
      },
    });
    dialogFile.afterClosed().subscribe((res) => {
      if (res && res.isUpdated && res.pre && res.uuid) {
        const filename = res.uuid.split('/').pop();
        this.newAvatar = { name: filename };
        this.basicInfo.avatar = res.pre;
        this.basicInfo.avatarUUID = res.uuid;
        this.patientProfile = res.pre;
        this.needToChange = true;
        this.cdr.detectChanges();
      }
    });
  }

  getAge(dateOfBirth: string): number {
    return moment().diff(dateOfBirth, 'years', false);
  }

  openFocusedViewDialog(contact) {
    this.dialog.open(CreateFilteredViewDialogComponent, {
      width: '800px',
      disableClose: true,
      data: {
        sessionOpened: false,
        entity: contact,
        type: 'PATIENT',
      },
    });
  }
  showPatientPhoto(patient) {
    if (!this.patient.pre_signed_url?.url) {
      return;
    }
    this.dialog.open(ZoomInEntityComponent, { data: { entity: patient }, maxWidth: '600px' });
  }
  firstLine() {
    const titleOne = document.querySelector('.title-one') as HTMLElement;
    const text =
      (this.patient.first_name ? this.patient.first_name : '') +
      ' ' +
      (this.patient.middle_name ? this.patient.middle_name : '');
    const textLength = text.length;
    const fontSize = Math.floor(220 / textLength);
    const newSize = (fontSize + 5) * 8 - 15;
    titleOne.style.fontSize = textLength < 16 ? 20 + 'px' : newSize + '%';
    return text;
  }

  secondLine() {
    const titleTwo = document.querySelector('.title-two') as HTMLElement;
    const text2 =
      (this.patient.last_name ? this.patient.last_name : '') +
      ' ' +
      (this.patient.last_name2 ? this.patient.last_name2 : '');
    const textLength2 = text2.length;
    const fontSize2 = Math.floor(220 / textLength2);
    const newSize2 = (fontSize2 + 5) * 8 - 15;
    titleTwo.style.fontSize = textLength2 < 16 ? 20 + 'px' : newSize2 + '%';
    return text2;
  }
  addressLine() {
    return (
      (this.patient?.address_1 ? this.titleCasePipe.transform(this.patient.address_1) + ', ' : '') +
      (this.patient?.address_2 ? this.titleCasePipe.transform(this.patient.address_2) + ', ' : '') +
      (this.patient?.city ? this.titleCasePipe.transform(this.patient.city) + ', ' : '') +
      (this.patient?.state ? this.patient.state + ' ' : '') +
      (this.patient?.zip ? this.patient.zip : '')
    );
  }
  changeTab(index) {
    this.tabs = this.tabs.map((item) => {
      item.active = item.index === index;
      return item;
    });
    this.insertParam(index);
  }

  insertParam(value) {
    if (this.fromCanvas) return;
    const queryParams = { tab_index: +value };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
  openFocusedSelectContact() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '500px';
    dialogConfig.data = { patientId: this.patient.id };
    const dialogRef = this.dialog.open(StartFocusedViewFromEntityComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.openFocusedViewDialog(result);
      }
    });
  }
  getTabsNumber(): number {
    const panel2Height = document.getElementById('panel_2').offsetHeight;
    const heightOfTab = 45.5;
    const numberOfTabs = panel2Height / heightOfTab - 3;
    return numberOfTabs;
  }
}
